import { render, staticRenderFns } from "./AnnouncementListingService.vue?vue&type=template&id=180d5704"
import script from "./AnnouncementListingService.vue?vue&type=script&lang=js"
export * from "./AnnouncementListingService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports